import type { SVGProps } from 'react'
const SvgCrossForChip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.75 1.80848L9.6925 0.750977L5.5 4.94348L1.3075 0.750977L0.25 1.80848L4.4425 6.00098L0.25 10.1935L1.3075 11.251L5.5 7.05848L9.6925 11.251L10.75 10.1935L6.5575 6.00098L10.75 1.80848Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default SvgCrossForChip
